export enum DiscountEnum {
  PERCENT ='PERCENT',
  FIXED  ='FIXED',
  EMPTY ='',
} 
export interface IPromocode {
  id: string;
  code: string,
  discountType: DiscountEnum ,
  discountValue: number,
  maxUses?: number | null,
  userLimit?: number | null,
  minOrderValue?: number | null,
  startDate?: string | null,
  endDate?: string | null,
  courseIds?: string[],
  planIds?: string[]
}

export interface IPromocodeInput {
  code: string,
  discountType: DiscountEnum ,
  discountValue: number,
  maxUses?: number | string | null,
  userLimit?: number | null,
  minOrderValue?: number | null,
  startDate?: string | null,
  endDate?: string | null,
  courseIds?: string[],
  planIds?: string[]
}

export interface IPromocodeEditBody {
  id: string;
  values: IPromocodeInput;
}
